import { cn } from "@/lib/utils";
import { DetailedHTMLProps, HTMLAttributes, forwardRef } from "react";

export const Divider = forwardRef<
    HTMLDivElement,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
>(({ className, ...props }, ref) => {
    return (
        <div
            ref={ref}
            className={cn(
                "w-full border-b border-component-divider-line",
                className
            )}
            role="separator"
            aria-orientation="horizontal"
            {...props}
        />
    );
});

Divider.displayName = "Divider";
